var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.90894 19.4062L16.5552 12.854C16.6784 12.7484 16.7773 12.6174 16.845 12.47C16.9128 12.3226 16.9479 12.1622 16.9479 12C16.9479 11.8377 16.9128 11.6774 16.845 11.5299C16.7773 11.3825 16.6784 11.2515 16.5552 11.1459L8.90894 4.59371C8.1791 3.96839 7.05176 4.48683 7.05176 5.44777V18.554C7.05176 19.515 8.1791 20.0334 8.90894 19.4062Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretRight);
export default __webpack_public_path__ + "static/media/Caret-Right.f11a62aa9821f48c6500178e41a0fcf2.svg";
export { ForwardRef as ReactComponent };